export default "__VITE_ASSET__BIKCPy_Y__"